export const getPrintTemplate = (values) => {
  const { rows = [], debitAccountLabels = [], totals = {} } = values;
  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const tableRows = rows.map((row) => `
    <tr>
      <td style="border:1px solid #000;padding:4px;text-align:center">${row.index}</td>
      <td style="border:1px solid #000;padding:4px;text-align:center">${row.voucherNumber}</td>
      <td style="border:1px solid #000;padding:4px;text-align:center">${row.voucherDate}</td>
      <td style="border:1px solid #000;padding:4px">${row.description}</td>
      ${(row.creditValues || []).map(v => `<td style="border:1px solid #000;padding:4px;text-align:right">${fmt(v)}</td>`).join("")}
      <td style="border:1px solid #000;padding:4px;text-align:right;background-color:#eee"><b>${fmt(row.totalCredit331)}</b></td>
    </tr>
  `).join("");

  const totalCols = (totals.creditValues || []).map(v => `<td style="border:1px solid #000;padding:4px;text-align:right"><b>${fmt(v)}</b></td>`).join("");

  return `
    <div style="font-family:'Times New Roman',Times,serif;padding:20px;color:#000;background:#fff;font-size:12px;line-height:1.4">
      <div style="display:flex;justify-content:space-between">
        <div style="width:40%">
          <div><b>Đơn vị:</b> ${values.unit}</div>
          <div><b>Địa chỉ:</b> ${values.address}</div>
        </div>
        <div style="text-align:center;width:60%">
          <div style="font-weight:bold;font-size:14px">Mẫu số S04a5-DN</div>
          <div style="font-style:italic;font-size:10px">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      <div style="text-align:center;margin:15px 0">
        <h2 style="margin:0;text-transform:uppercase;font-size:16px">NHẬT KÝ CHỨNG TỪ SỐ 5</h2>
        <div style="font-style:italic;font-size:12px">Ghi Có Tài khoản 331 - Phải trả cho người bán</div>
        <div style="margin-top:5px;font-weight:bold">Tháng ${values.month} năm ${values.year}</div>
      </div>

      <table style="width:100%;border-collapse:collapse;font-size:11px">
        <thead>
          <tr>
            <th style="border:1px solid #000;padding:4px;text-align:center" rowspan="2">Số TT</th>
            <th style="border:1px solid #000;padding:4px;text-align:center" colspan="2">Chứng từ</th>
            <th style="border:1px solid #000;padding:4px;text-align:center" rowspan="2">Diễn giải</th>
            <th style="border:1px solid #000;padding:4px;text-align:center" colspan="10">Ghi Nợ các Tài khoản đối ứng</th>
            <th style="border:1px solid #000;padding:4px;text-align:center;width:80px" rowspan="2">Tổng cộng ghi Có TK 331</th>
          </tr>
          <tr>
            <th style="border:1px solid #000;padding:4px;text-align:center;width:60px">Số hiệu</th>
            <th style="border:1px solid #000;padding:4px;text-align:center;width:60px">Ngày</th>
            ${debitAccountLabels.map(l => `<th style="border:1px solid #000;padding:4px;text-align:center;width:70px">${l || ""}</th>`).join("")}
          </tr>
          <tr style="background-color:#f0f0f0">
            <th style="border:1px solid #000;padding:2px;text-align:center">A</th>
            <th style="border:1px solid #000;padding:2px;text-align:center">B</th>
            <th style="border:1px solid #000;padding:2px;text-align:center">C</th>
            <th style="border:1px solid #000;padding:2px;text-align:center">D</th>
            ${[...Array(10)].map((_, i) => `<th style="border:1px solid #000;padding:2px;text-align:center">${i + 1}</th>`).join("")}
            <th style="border:1px solid #000;padding:2px;text-align:center">11</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
          <tr style="font-weight:bold;background-color:#fafafa">
            <td style="border:1px solid #000;padding:4px;text-align:center" colspan="4">Cộng</td>
            ${totalCols}
            <td style="border:1px solid #000;padding:4px;text-align:right">${fmt(totals.totalCredit331)}</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top:10px">
        Đã ghi Sổ Cái ngày ${values.recordedToLedgerDay} tháng ${values.recordedToLedgerMonth} năm ${values.recordedToLedgerYear}
      </div>

      <div style="display:flex;justify-content:space-between;margin-top:20px;text-align:center">
        <div style="width:30%">
          <div style="font-weight:bold">Người ghi sổ</div>
          <div style="font-style:italic;font-size:10px">(Ký, họ tên)</div>
          <div style="margin-top:50px">${values.ledgerClerk || "...................."}</div>
        </div>
        <div style="width:30%">
          <div style="font-weight:bold">Kế toán trưởng</div>
          <div style="font-style:italic;font-size:10px">(Ký, họ tên)</div>
          <div style="margin-top:50px">${values.chiefAccountant || "...................."}</div>
        </div>
        <div style="width:40%">
          <div style="font-style:italic;font-size:12px;margin-bottom:3px">
            Ngày ${values.signingDay} tháng ${values.signingMonth} năm ${values.signingYear}
          </div>
          <div style="font-weight:bold">Người đại diện theo pháp luật</div>
          <div style="font-style:italic;font-size:10px">(Ký, họ tên, đóng dấu)</div>
          <div style="margin-top:50px">${values.legalRepresentative || "...................."}</div>
        </div>
      </div>
    </div>
  `;
};
